import tj from "./tj/zh-CN";
const zh_CN = {
    'intl.hello': "你好",
    'intl.name': '我的名字是 {name}',
    "intl-Nav-Home": "首页",
    "intl-Nav-Center": "中心概览",
    "intl-Nav-Activities": "主题活动",
    "intl-Nav-News": "最新动态",
    "intl-Nav-AboutUs": "参观须知",
    "intl-Nav-Login": "登录",
    "intl-Nav-Register": "注册",
    "intl-Menu-Email": "邮箱",
    "intl-Menu-Phone": "手机",
    "intl-Menu-Hours": "时间",


    "intl-Home-AboutUs": "联想未来中心",
    "intl-Home-Character": "这是一种很好的方法，它可以让你的身体变得更健康。你可以在这里看到我的名字，我的名字是我的名字。这是一种很有价值的东西，它是一种很有价值的东西，它是一种很有价值的东西，它是一种很有价值的东西。这是一种不正常的解释，它是一种艺术，它是一种艺术。",
    "intl-Home-aboutPart1": "一座用智能科技搭建的桥梁，连接中国与世界、当下与未来、现实与想象。",
    "intl-Home-aboutPart2": "在这里，",
    "intl-Home-aboutPart3": "为到访者提供全智能生活体验；",
    "intl-Home-aboutPart4": "为企业提供数字化转型思维和方法；",
    "intl-Home-aboutPart5": "为行业在智能化变革中寻求整合的解决方案；",
    "intl-Home-aboutPart6": "为社会贡献连接未来的创新思想力。",
    "intl-Home-JOINLENOVO": "走进联想，走近未来",
    "intl-Home-Sun": "日",
    "intl-Home-Mon": "一",
    "intl-Home-Tue": "二",
    "intl-Home-Wed": "三",
    "intl-Home-Thu": "四",
    "intl-Home-Fir": "五",
    "intl-Home-Sat": "六",
    "intl-Home-Mayapply": "可预约",
    "intl-Home-Application": "预约已满",
    "intl-Home-ACITIVITES": "活动",
    "intl-Home-Ipsum": "我在海上，在法定的荣誉中。我的结论是。海洋环境",
    "intl-Home-development": "发展",
    "intl-Home-CREATING": "策略",
    "intl-Home-REVOLUTION": "幻灯片",
    "intl-Home-Alienum": "这是一种很好的方法，它可以让你的身体变得更健康。我是一个有精神的人，我的朋友，我的朋友。",
    "intl-Home-MORE": "更多",



    "intl-AboutUS-ABOUTSUS ": "参观须知",
    "intl-AboutUS-title1": "追求最优质的参观体验，在这里读懂联想，更读懂我们每个人的未来",
    "intl-AboutUS-title2": " ",
    "intl-AboutUS-happened ": "追求最优质的参观体验，在这里读懂联想，更读懂我们每个人的未来",
    "intl-AboutUS-Paragraph1 ": "联想经过 30" +
        "                                        多年的发展，从一家中国公司成长为一家全球化跨国企业，业务从单一业务转化为多元化业务，同时从全球 PC" +
        "                                        产业引领者逐步演变为以“设备+云”和“基础设施+云”的产业构建者，以广泛的智能设备制造、服务能力和超级计算力构建能力，为全球提供广泛的智能化设备、服务和人" +
        "                                        工智能时代的核心计算力，成为人工智能时代的赋能者。",

    "intl-AboutUS-Paragraph2": "联想创新展示中心通过> 联想创新展示中心通过“智能生活”场景对联想产品及科技的运用，集中展示未来智能家居、智能工作、智能出行及智能娱乐等方面的内容，并通过基于物联网和人工智能算法平台，形成对整体智能生活方面的技术支撑。",

    "intl-AboutUS-Paragraph3": "在智能行业展示中，通过构建计算力、大数据和算法平台的内容，体现智能制造、智能医疗、智能教育、智能金融以及智慧城市、智能能源等各行业的系统解决方案及各行业的技术突破点，系统性地展示在智能行业的发展中，联想所赋能者的地位和技术领先性",
    "intl-AboutUS-Paragraph4": "在智能行业展示中，通过构建计算力、大数据和算法平台的内容，体现智能制造、智能医疗、智能教育、智能金融以及智慧城市、智能能源等各行业的系统解决方案及各行业的技术突破点，系统性地展示在智能行业的发展中，联想所赋能者的地位和技术领先性",
    "intl-AboutUS-Paragraph5": "联想创新展示中心能帮您“联接世界的想象”，带领您进入联想的智能未来世界。",
    "intl-AboutUS-operationGuide": "联想VLEC操作指南",
    "intl-AboutUS-Introduction": "参观指南",
    "intl-AboutUS-Admissions": "开放时间",
    "intl-AboutUS-Facilities": "设施服务",
    "intl-AboutUS-FAQ": " 常见问题",
    "intl-AboutUS-Directions": " 交通指南",
    "intl-AboutUS-Hours": "开馆时间",
    "intl-AboutUS-TheTimeThat": "- 周一至周六: 09:00-18:00 (需提前预约)",
    "intl-shAboutUS-TheTimeThat": "- 周一至周五：9:00-18:00 （需提前预约）",
    "intl-AboutUS-TheTimeThat1": "- 周六: 9a.m. - 5p.m. (最后一次入场时间为下午4:30 )",
    "intl-AboutUS-Closed": "闭馆时间",
    "intl-AboutUS-ClosedTime": "- 周日",
    "intl-AboutUS-ClosedTime1": "- 法定节假日",
    "intl-AboutUS-Museum": "场馆指南",
    "intl-AboutUS-Weekdays": "-工作日",
    "intl-AboutUS-Weekdays1": "需要提前预约(由场馆工作人员引导参观)",
    "intl-AboutUS-Weekdays2": "所有工作日的访客必须提前预订。",
    "intl-AboutUS-Weekdays3": "导游团每组最多可容纳30人。(如果您的团队人数超过30人，则会被分成最多30人的小组。)",
    "intl-AboutUS-Saturdays": "- 每逢星期六",
    "intl-AboutUS-Saturdays1": "-不需要预订 ",
    "intl-AboutUS-Saturdays2": " ※星期六没有导游陪同",
    "intl-AboutUS-VisitorsGuide": " 参观指南",
    "intl-AboutUS-VisitorsGuide1": "•	联想未来中心目前仅针对团体访客开放参观预约",
    "intl-AboutUS-VisitorsGuide2": "•	需至少提前10天进行预约",
    "intl-AboutUS-VisitorsGuide3": "•	参观预约后，是否预约成功请以邮件为准",
    "intl-AboutUS-VisitorsGuide4": "•	为保证最佳的参观体验，每次参观人数需控制在30人以内",
    "intl-szAboutUS-VisitorsGuide4": "•	为保证最佳的参观体验，每次参观人数需控制在20人以内",
    "intl-AboutUS-VisitorsGuide4-0": "•	18岁以下访客需由至少一名成人陪同方可入场",
    "intl-AboutUS-VisitorsGuide4-1": "•	行动不便的参观者需由成年人陪同",
    "intl-AboutUS-VisitorsGuide4-2": "•	禁止携带宠物进入展厅",
    "intl-AboutUS-VisitorsGuide5": " •	请勿大声喧哗并请将手机设置为静音或震动模式以免影响他人参观",
    "intl-AboutUS-VisitorsGuide6": " •	展厅内禁止吸烟、进食",
    "intl-AboutUS-VisitorsGuide6-1": "  ※ 30人团队参观须有一名监护人陪同",
    "intl-AboutUS-VisitorsGuide7": "•	禁止损毁建筑、设施和展品，乱涂乱画",
    "intl-AboutUS-VisitorsGuide8": "•	请注意言行举止",
    "intl-AboutUS-VisitorsGuide9": "•	场馆内请勿奔跑、追逐、攀爬、躺卧",
    "intl-AboutUS-VisitorsGuide10": " •  请协助维持展厅内的参观秩序和良好的参观环境",
    "intl-AboutUS-VisitorsGuide10-1": " ※ 请勿穿人字拖.",
    "intl-AboutUS-VisitorsGuide11": "•	出于展项安全的考虑，仅在场馆内指定区域允许照相、录音（电视节目拍摄需提前与相关工作人员沟通）",
    "intl-AboutUS-VisitorsGuide12": "•	",
    "intl-AboutUS- Facilities1": " 停车位",
    "intl-AboutUS- Facilities1-1": "咨询服务台",
    "intl-AboutUS- Facilities1-2": "储物柜",
    "intl-AboutUS- Facilities2": "为方便您出行，联想园区内设有访客专用停车位，下车后步行300米即可到达未来中心",
    "intl-AboutUS- Facilities3": "•  开放时间：周一至周六：9:00-18:00",
    "intl-AboutUS- Facilities4": "•	预约方式：当您收到参观安排确认邮件时，工作人员会与您沟通车位预留事宜",
    "intl-AboutUS- Facilities5": "•	停车位置：访客可自驾车从联想总部东区西口驶入，并按照交通引导抵达访客专用停车场",
    //
    "intl-AboutUS-Facilities6": "•	位置：场馆入口处右侧",
    "intl-AboutUS-Facilities7": "•	可解答场馆相关问题、提供基础服务",
    "intl-AboutUS-Facilities8": "•	使用时间：周一至周六: 09:00-18:00",
    "intl-AboutUS-Facilities9": "•	每天18:00后留在储物柜中的物品将被取出、单独存放3天，3天之后无人认领的物品将被丢弃",
    "intl-AboutUS-Facilities10": "•	遗失物品，后果自负；贵重物品请随身携带",
    "intl-AboutUS-ban1": "•	枪支、军用或警用械具类（含主要零部件）及上述物品的仿制品",
    "intl-AboutUS-ban2": "•	爆炸物品类，包括炸药、爆破器材、烟花爆竹制品及上述物品的仿制品",
    "intl-AboutUS-ban3": "•	管制刀具类；其他可能妨碍他人参观、造成他人人身伤害或财产损失、扰乱展厅秩序和危害展厅安全的物品",
    "intl-AboutUS-ban4": "•	管制刀具以外的利器、钝器",
    "intl-AboutUS-ban5": "•	易燃易爆物品，如：酒精、汽油、煤油、柴油、打火机、火柴、发胶、摩丝、指甲油、染发剂、去光剂等",
    "intl-AboutUS-ban6": "•	带有毒害性、腐蚀性的危险物质",
    "intl-AboutUS-ban7": "•	除上述物品以外，中国法律法规明令禁止的其他可能影响观众参观或展品安全的物品",
    "intl-AboutUS-site": "地址：",
    "intl-AboutUS-site1": "北京市海淀区西北旺东路中关村软件园10号院1号楼联想总部东区内",
    "intl-shAboutUS-site1": "上海市浦东新区松涛路696号联想创新科技园A座5F",
    "intl-AboutUS-Phone": "地铁：",
    "intl-AboutUS-Phone1": "乘坐地铁16号线到达西北旺地铁站，C东南口出站，随后步行1.8公里到达联想总部东区",

    "intl-Activities-NumberOfVisitors": "团体信息",
    "intl-Activities-NumberOfVisitors2": "参观人数",
    "intl-Activities-Datails": "联系人信息",
    "intl-Activities-Confirmation": "信息确认",
    "intl-Activities-group": "请提供来宾信息。",
    "intl-Activities-Individual": "*请填写如下内容",

    "intl-Activities-teamTitle": "与您的团队共同商定商务合作、公共活动等",
    "intl-Activities-CustomerInformation": "团体信息",
    "intl-Activities-Title": "职务",
    "intl-Activities-VisitingPurpose": "来访目的",
    "intl-Activities-GroupInfo": "团体简介",
    "intl-Activities-VisitTime": "期望到访时间",
    "intl-Activities-CityCascade": "来访地区",
    "intl-Activities-Dateofvisit": "来访日期",
    "intl-Activities-VisitingTime": "参观时间",
    "intl-Activities-Subordinate": "行业类别",
    "intl-Activities-VisitTheUnit": "团体名称",
    "intl-Activities-VisitBumber": "期望参访人数",
    "intl-Activities-VisitGroup": "参访人员群体",
    "intl-Activities-City": "区域",
    "intl-Activities-language": "接待语言",
    "intl-Activities-Note": "备注",
    "intl-Activities-otherPurpose": "说明",
    "intl-Activities-purpose": "合作需求",
    "intl-Activities-demandtxt": "请填写其他的合作需求说明",
    "intl-Activities-yycg": "预约参观",
    "intl-Activities-hdzx": "活动咨询",
    "intl-Activities-mthz": "媒体合作",
    "intl-Activities-qt": "其他",
    "intl-Activities-language1": "中文",
    "intl-Activities-language4": "英语",
    "intl-Activities-Next": "下一步",
    "intl-Activities-Previous": "上一步",
    "intl-Activities-Submit": "提交",
    "intl-Activities-tjxx": "提交信息",

    "intl-Activities2-Please": "请选择参观人数",
    "intl-Activities2-Guided": "为保证最佳的参观体验，每次参观人数需控制在30人以内，敬请谅解。18岁以下访客需由至少一名成人陪同方可入场。",

    "intl-Activities2-Number": "参观人数",

    "intl-Activities2-Under": "12岁以下",
    "intl-Activities2-Eighteen": "13岁至18岁",
    "intl-Activities2-Students": "大学生",
    "intl-Activities2-Adults": "18岁以上",
    "intl-Activities2-Total number of visitors ": "总参观人数 ",
    "intl-Activities2-People": "人",
    "intl-Activities3-details": "请提供参观详细信息",
    "intl-Activities3-Information": "联系人信息",
    "intl-Activities3-name": "姓名",
    "intl-Activities3-phone": "手机号",
    "intl-Activities3-E-mail": "邮箱",
    "intl-Activities3-Nationality": "国家",
    "intl-Activities3-Occupation": "职位",
    "intl-Activities3-China": "中国",
    "intl-Activities3-TheBritish": "英国",
    "intl-Activities3-Japan": "日本",
    "intl-Activities3-TheUnitedStates": "美国",
    "intl-Activities3-I agree": "我同意",
    "intl-Activities3-I disagree": "我不同意",

    "intl-Activities5-Information": "请确认信息",
    "intl-Activities5-Contact": "联系人信息",





    "intl-InnovationCenter-InnovationCenter": "展厅介绍",
    "intl-InnovationCenter-Ipsum": "我在海上，在法定的荣誉中。我的结论是。海的前女友海洋环境",
    "user-hello": "你好,",
    "intl-Nav-Logout": "注销",
    "send-verifycode": "发送验证码",
    "upper-limit": "上限",
    "intl-location": "地点",
    "intl-activityContent": "活动内容",
    "intl-agenda": "行程安排",
    "intl-activityRule": "活动规则",
    "intl-Publish-Date": "发布日期",
    "intl-VisitorsInfo": "访客信息（请填写每位访客信息）",
    "intl-Operation": "操作",
    "intl-viewdetail": "查看详情",
    "intl-Activities3-InterestTopic": "感兴趣的话题",
    "intl-inputNumer": "请输入数字",
    "intl-agree-lenovoService": "I agree to the Terms and Conditions of the Lenovo service.",
    "intl-agree-personalInfo": "I agree to the collection and use of personal information.",
    "intl-agree-requiredPersonalInfo": "I agree to the collection and use of required personal information",
    "intl-agree-optionalPersonalInfo": "I agree to the collection and use of optional personal information",
    "intl-succeedTip": "您的信息已提交，工作人员将在3个工作日内与您联络，预约成功与否请以邮件为准，请关注您的邮箱。",
    "intl-succeedTip2": " ",
    "intl-succeedTitle": "恭喜，您的信息提交成功",
    "intl-backHome": "返回首页",
    "intl-Nav-GroupApply": "团体预约",
    "intl-peopleNumber": "请输入整数",
    "intl-qrTip": "扫描二维码，关注联想创新中心公众号，快来报名参观吧~",
    "intl-welcome": "欢迎",
    "intl-GroupReservation": '继续团体预约',
    "intl-EventSignUp": '报名参与活动',
    "intl-ActivityTip": '联想未来中心目前仅针对团体访客开放参观预约。若您为个人访客，欢迎进入活动页面，报名参与各类活动',

    "intl-checkTip": "我同意收集和使用所填信息",
    "intl-PrivacyPolicy": "隐私条款",
    "intl-ComingSoon": "敬请期待",

    "intl-Menu-Terms": "使用条款",
    "intl-Menu-Privacy": "隐私声明",
    "intl-Menu-Directions": "交通指南",
    "intl-Menu-Links": "友情链接",
    "intl-Menu-Weibo": "官方微博",
    "intl-Menu-WeChat": "官方微信",
    "intl-Menu-Contact": "联系方式：",
    "intl-Menu-Address": "中心地址：联想北京未来中心，北京市海淀区西北旺东路中关村软件园10号院1号楼联想总部东区内",
    "intl-Menu-LenovoGroup": "联想集团官网",
    "intl-Menu-LenovoStore": "联想商城官网",
    "intl-home-month": "月",
    "intl-home-year": "年",
    "intl-home-Possibilities1": "联想用户、会员和粉丝的聚集地",
    "intl-home-Possibilities2": "以科技为导向，倡导文化、艺术和思考",
    "intl-home-Possibilities3": "这里，不止于联想",
    //center
    "intl-center-title": "智能，为每一个可能",
    "intl-center-title2": "致力于打造科技新地标，集中展现联想智慧创新力与思想引领力。",
    "intl-center-title2_1": " ",
    "intl-center-title3": "联想北京未来中心总面积约6500平米，其中包含多元智能场景体验和多种行业解决方案展示。",
    "intl-center-title3_1": " ",
    "intl-center-f1Title": "联想未来中心1层——3000平米",
    "intl-center-f1Title2": "智能生活之旅",
    "intl-center-f1Des": "面向消费用户展示联想多元文化及全球化进程、计算和数据演进历史、当下及未来可期的智能生活体验。",
    "intl-center-f2Title": "联想未来中心2层——2000平米",
    "intl-center-f2Title2": "智慧行业之旅",
    "intl-center-f2Des": "面向企事业客户及合作伙伴，全面介绍联想在商用设备、数据中心业务及制造、医疗、教育等行业的智能解决方案。",
    "intl-center-f3Title": "联想未来中心3层——1000平米",
    "intl-center-f3Title2": "Next空间",
    "intl-center-f3Des": "作为多元领域思维碰撞、创新交流、产品/方案发布的开放空间，Next空间可为科技、文化、艺术等主题活动提供场所。",
    "intl-center-dataTitle": "数据芯流",
    "intl-center-dataDes1": "数据是驱动智能变革的基础燃料，可以助力实现机器间高效自然的沟通互动，使数据和服务在不同终端之间自由流转。",
    "intl-center-dataDes2": "联想未来中心的“能量水滴”可以快速识别来宾并激活来宾专属的 “数据芯流” ，点亮全场。数据芯流将呈波浪状 “融入” 各个场景背后的算力、算法平台，“触发” 不同生活、产业场景的智能变革。",
    "intl-center-historyTitle": "历史长廊",
    "intl-center-historyDes1": "在这里，通过18米210°的环绕透视屏，以全维立体的方式，呈现沉浸式的趣味体验，共同回顾从结绳记事起，被数据和算力所推动的人类发展历程。",
    "intl-center-historyDes2": "伴随着科技的进步，联想通过数据和计算力二者的完美融合，为用户带来优质产品和服务体验。",
    "intl-center-lifeTitle": "未来家庭生活体验",
    "intl-center-lifeDes1": "借助联想SIoT（智能物联网）云平台，家庭设备如同贴心管家，提供全面无缝的生活对接。无论是追剧、阅读，还是健身、饮食，联想将用户、智能设备和云服务整合，打造未来智能生活。",
    "intl-center-lifeDes2": "通过对各类智能设备、传感器、声音和图像采集以及云服务平台对数据的高效处理能力，将个性化的生活服务推送到用户面前。",
    "intl-center-meetingTitle": "智能办公",
    "intl-center-meetingDes1": "联想致力于为商务人士提供各种产品和一站式智能场景化解决方案，助力全天候高效，帮助企业提升运营效率，改善经营。",
    "intl-center-gameTitle": "专业电竞游戏娱乐",
    "intl-center-gameDes1": "感受由联想专业电竞设备带来的全新PC游戏体验——",
    "intl-center-gameDes2": "深入丛林险境，亦或是畅游太空；无论是冒险者的乐园，还是想象力驰骋的疆土，联想AR、VR游戏设备都能带你一触即达。",
    "intl-center-madeTitle": "智能制造",
    "intl-center-madeDes1": "联想积极发展智能制造，引领产业升级。",
    "intl-center-madeDes2": "联想拥有优秀的全球供应链和生产管理体系，年累计出货1亿台设备，制造物流网络辐射全球。联想通过先进技术重塑端到端的智能制造体系，包括智能化的供应链管理系统、高度自动化的混线柔性生产、产品设计和制造过程中的虚实结合、端到端的质量追溯、监控、分析和管理，以及通过大数据和人工智能驱动预测性分析决策的诸多能力。",
    "intl-center-madeDes3": "联想围绕智能制造核心能力，不断进行实践推广，坚持个性化、定制化的客户视角，将持续为行业智能化升级提供不竭动力。",
    "intl-center-medicalTitle": "智慧医疗",
    "intl-center-medicalDes1": "联想利用自身的数字化能力积极探索，让更多人享受更优质的医疗资源。帮助许多地区医院以及养老机构，建立新型的智慧医疗体系，实现 “信息互通、实时监管、随叫随到”的养老服务；力图求解慢病全生命周期的科学管理问题；助力医院实现智能化改造等。",
    "intl-center-medicalDes2": " ",
    "intl-center-educationTitle": "智慧教育",
    "intl-center-educationDes1": "随着教育信息化2.0时代的到来，联想以AI赋能教育信息化，让教育管理者和每一位教师、学生都能享受智慧教育的切实价值。基于虚实融合、人机交互，以及OCR等核心技术，联想研发了智慧教育核心技术引擎，并在此基础上打造了一系列智慧教育方案，赋能数千所学校。",
    "intl-center-educationDes2": " ",
    "intl-center-educationDes3": " ",
    "intl-event-title1": "联想用户、会员和粉丝的聚集地",
    "intl-event-title2": "以科技为导向，倡导文化、艺术和思考",
    "intl-event-title3": "这里，不止于联想",
    "intl-aboutus-reservations": "参观预约",
    "intl-aboutus-notes": "参观注意事项",
    "intl-aboutus-prohibited": "入场禁带物品",
    "intl-news-title": "最新动态",
    "intl-news-title1": "向着未来智能的时代，这里提供我们征程上的每一滴讯息",
    "intl-aboutus-click": "	点击{here}获取交通指南",
    "intl-aboutus-here": "此处",
    "intl-area-sh": "上海",
    "intl-area-bj": "北京",
    "intl-area-sz": "深圳",
    "intl-area-tj": "天津",
    "intl-area-tjltzngc": "零碳智能工厂",
    "intl-shcenter-citytitle": "智慧城市",
    "intl-shcenter-citydes": "基于“端-边-云-网-智”的新IT架构，联想从顶层设计到智慧城市生态系统各类要素的落地、运维，助力多地共同构筑真实丰满的智慧生活愿景。",
    "intl-shcenter-manufacturingtitle": "智能制造",
    "intl-shcenter-manufacturingdes1": "作为以数据智能为核心进行智能化转型的先行者，联想已经形成了覆盖“研产供销服”全价值链的智能化技术和管理体系。在输出自身的智能化转型经验和先进技术的同时，还为其他企业的转型赋能。",
    "intl-shcenter-manufacturingdes2": "基于计算视觉技术为高端制造提供智能源动力。",
    "intl-shcenter-educationtitle": "智慧教育",
    "intl-shcenter-educationdes": "围绕教/学/测/评/管等核心教育场景，打造智慧校园、智慧课堂、智慧考场、创新教学体验。",
    "intl-shcenter-agriculturetitle": "智慧农业",
    "intl-shcenter-agriculturedes": "联想“Le农 ”智慧农业解决方案从顶层规划整体数字乡村发展战略，赋能多地产业智能化转型、助力乡村振兴。",
    "intl-shcenter-officetitle": "智能办公",
    "intl-shcenter-officedes": "智慧访客，智能工位和智能会议等全场景办公解决方案，助力企业数字化、精细化管理。",
    "intl-shAboutUS-VisitorsGuide1": "• 展厅内禁止吸烟",
    "intl-shAboutUS-VisitorsGuide2": "• 为保证最佳的参观体验，每批参观人数需控制在15人以内",
    "intl-shAboutUS-VisitorsGuide3": "• 未成年人或行动不便的参观者需有陪同人员共同参观",
    "intl-shAboutUS-VisitorsGuide4": "• 禁止损毁建筑、设施和展品，乱涂乱画",
    "intl-shAboutUS-VisitorsGuide5": "• 场馆内请勿奔跑、追逐、攀爬、躺卧",
    "intl-shAboutUS-VisitorsGuide6": "• 若需在展厅摄影摄像，请提前与工作人员确认",
    "intl-shAboutUS-VisitorsGuide7": "• 请将手机设置为静音或震动模式以免影响他人参观",
    "intl-shAboutUS-know": "参观注意事项",
    "intl-shAboutUS-yuyue": "参观预约",
    "intl-shAboutUS-yuyue1": "• 联想上海未来中心目前仅针对团体访客开放参观预约",
    "intl-shAboutUS-yuyue2": "• 需至少提前10天进行预约",
    "intl-shAboutUS-yuyue3": "• 参观预约后，是否预约成功请以邮件为准",
    "intl-shAbountUS-jindai": "入场禁带物品",
    "intl-shAbountUS-jindai1": "• 枪支、军用或警用械具类（含主要零部件）及上述物品的仿制品",
    "intl-shAbountUS-jindai2": "• 爆炸物品类，包括炸药、爆破器材、烟花爆竹制品及上述物品的仿制品",
    "intl-shAbountUS-jindai3": "• 管制刀具类；其他可能妨碍他人参观、造成他人人身伤害或财产损失、扰乱展厅秩序和危害展厅安全的物品",
    "intl-shAbountUS-jindai4": "• 管制刀具以外的利器、钝器",
    "intl-shAbountUS-jindai5": "• 易燃易爆物品，如：酒精、汽油、煤油、柴油、打火机、火柴、发胶、摩丝、指甲油、染发剂、去光剂等",
    "intl-shAbountUS-jindai6": "• 带有毒害性、腐蚀性的危险物质",
    "intl-shAbountUS-jindai7": "• 除上述物品以外，中国法律法规明令禁止的其他可能影响观众参观或展品安全的物品",
    "intl-shAbountUS-jindai8":" ",
    "intl-Home-shAboutUs": "联想上海未来中心",
    "intl-shAboutUS-ditieTitle": "地铁：",
    "intl-shAboutUS-ditie": "2号线张江高科站（5号口出）",
    "intl-shAboutUS-gongjiaoTitle": "公交：",
    "intl-shAboutUS-gongjiao": "浦东22路、大桥六线（碧波路祖冲之路站）、张江环线、188路、浦东70路、1090路（松涛路祖冲之路站）",
    "intl-shAboutUS-ClosedTime": "- 双休日",
    "intl-shAboutUS-Facilities1": "停车位",
    "intl-shAboutUS-Facilities2": "为方便您出行，联想创新科技园内设有访客专用停车位。",
    "intl-shAboutUS-Facilities3": "• 开放时间：周一至周五：9:00-18:00",
    "intl-shAboutUS-Facilities4": "• 预约方式：当您收到参观安排确认邮件时，工作人员会与您沟通车位预留事宜",
    "intl-shAboutUS-Facilities5": "咨询服务台",
    "intl-shAboutUS-Facilities6": "• 位置：联想创新科技园A座一层前台",
    "intl-shAboutUS-Facilities7": "• 服务台有联想未来中心手册供访客初步了解",
    "intl-shAboutUS-Facilities8": "• A座一层前台区域设有休息区",
    "intl-shAboutUS-Facilities9": "物品寄存",
    "intl-shAboutUS-Facilities10": "• 访客可将随身物品带至A座5层未来中心，参观前工作人员将与访客确认并为其存放",
    "intl-shAboutUS-Facilities11": "• 参观后，工作人员会与访客确认并将物品交还给访客",
    "intl-shAboutUS-Facilities12": "• 每天18:00后留在A座5层未来中心前台处的物品将被取出、单独存放3天，3天之后无人认领的物品将被丢弃",
    "intl-shAboutUS-Facilities13": "• 遗失物品，后果自负；贵重物品请随身携带",
    "intl-shcenter-title2":"联想未来中心是联想集团智能化转型战略的重要展示窗口，目前已落地北京、上海。",
    "intl-shcenter-title2_1":" ",
    "intl-shAboutUS-title1": "追求最优质的参观体验，在这里读懂联想，更读懂我们每个人的未来",
    "intl-shAboutUS-title2": " ",
    "intl-szcenter-ittitle": "新IT",
    "intl-szcenter-itdes": "这里展示了联想IT服务&3S战略的落地业务和实践，以及联想端-边-网-云-智的新IT技术架构。您可以看到联想大脑、Edge AI、小样本学习技术、边云网融合和超性能计算如何赋能各行各业的数字化和智能化转型。",
    "intl-szcenter-itdes1": "这里展示了联想IT服务&3S战略的落地业务和实践，以及联想端-边-网-云-智的新IT技术架构。您可以看到联想大脑、Edge AI、小样本学习技术、边云网融合和超性能计算如何赋能各行各业的数字化和智能化转型。",
    "intl-szcenter-itdes2": " ",
    "intl-szcenter-maketitle": "制造行业",
    "intl-szcenter-makedes": "智能制造展区围绕联想在智能制造领域的实践，全面地展现了联想研产供销服（研发、供应链、营销、销售、服务）全价值链环节的模式创新。联想独特的全球供应链、数字化研发生产和工业元宇宙平台的各个案例都展现于此。",
    "intl-szcenter-educationtitle": "教育行业",
    "intl-szcenter-educationdes1": "联想未来中心展现了联想教育业务部门在教育2.0时代以新型教育理念为教育行业用户提供从设备、应用到服务的端到端的整体解决方案。联想智慧教育以“科技至简，智慧为学”为追求，通过打造多元化产品矩阵，如数字黑板、教研一体机、理化生实验考场等产品，切实帮助一线教师群体更好地适用数字化、智能化的教学模式。",
    "intl-szcenter-educationdes2": "",
    "intl-szcenter-citytitle": "智慧城市",
    "intl-szcenter-citydes": "智慧城市建设涉及方方面面，环卫管理、交通疏解、危机处理，其中数字基础设施建设是重中之重。这里展示了联想在智慧城市和智慧园区建设中的最佳实践案例，展示联想在智慧城市管理运维方面的能力，以此为参访者提供更多关于城市创新能力与持续发展建设的灵感。",
    "intl-szcenter-ESGtitle": "ESG",
    "intl-szcenter-ESGdes1": "联想作为一家高科技企业，长期持续投身环境、社会与公司治理实践，一直致力于通过数字化、智能化的技术创新，做数字低碳转型的先行者与技术赋能者。",
    "intl-szcenter-ESGdes2": "在ESG展区，您可以了解到联想在ESG领域取得的成绩，从水冷服务器搭建的绿色数据中心，再到沙漠中的公益“联萌林”、长江白鱀豚的数字化保护，处处体现联想以科技创新赋能，持续创造社会价值。",
    "intl-szcenter-citytitle": "智慧城市",
    "intl-szcenter-citydes": "智慧城市展区展现了联想从车计算到5G+V2X的智慧交通方案，以及智慧城市、智慧园区等数字基础设施建设解决方案，用智能化赋能城市的长足发展。",
    "intl-szcenter-financetitle": "金融行业",
    "intl-szcenter-financedes": "金融行业展区展现了联想在金融行业打造的智能解决方案，为量化交易、核心交易、超低延时的金融提供基础设施支持，为金融行业保驾护航。",
    "intl-Home-shAboutUs": "联想深圳未来中心",
    "intl-szAboutUS-ditieTitle": "地铁：",
    "intl-szAboutUS-ditie1": "方案一: 乘坐2号线(8号线)到达后海站，A口出站，从联想后海中心西门进入，或从商业区穿行至写字楼一层大厅。",
    "intl-szAboutUS-ditie2": "方案二:乘坐11号线到达后海站，J口出站，向南直行三百米到达。",
    "intl-szAboutUS-jiacheTitle": "驾车：",
    "intl-szAboutUS-jiache": "",
    "intl-szAboutUS-ClosedTime": "- 双休日",
    "intl-szAboutUS-Facilities1": "停车位",
    "intl-szAboutUS-Facilities2": "为方便您出行，联想后海中心设有访客专用停车位。",
    "intl-szAboutUS-Facilities3": "• 开放时间：周一至周五：9:00-18:00",
    "intl-szAboutUS-Facilities4": "• 预约方式：当您收到参观安排确认邮件时，工作人员会与您沟通车位预留事宜",
    "intl-szAboutUS-Facilities5": "咨询服务台",
    "intl-szAboutUS-Facilities6": "• 位置：联想后海中心A座一层前台",
    "intl-szAboutUS-Facilities7": "• 服务台有联想未来中心手册供访客初步了解",
    "intl-szAboutUS-Facilities9": "物品寄存",
    "intl-szAboutUS-Facilities10": "• 访客可将随身物品带至A座6层深圳未来中心前台，参观前工作人员将与访客确认并存放",
    "intl-szAboutUS-Facilities11": "• 参观后，工作人员会与访客确认并将物品交还给访客",
    "intl-szAboutUS-Facilities12": "• 每天18:00后留在6层未来中心前台处的物品将被取出，并单独存放3天。3天之后无人认领的物品将被丢弃",
    "intl-szAboutUS-Facilities13": "• 遗失物品，后果自负；贵重物品请随身携带",
    "intl-szAboutUS-site1": "广东省深圳市南山区后海滨路与海德一道交叉口联想后海中心A座6层",
    "intl-Menu-shAddress": "联想上海未来中心，上海市浦东新区松涛路696号联想创新科技园A座5F",
    "intl-Menu-szAddress": "联想深圳未来中心，广东省深圳市南山区后海滨路与海德一道交叉口联想后海中心A座6层",
    "intl-Menu-fc":"联想北京未来中心",
    "intl-Menu-shfc":"联想上海未来中心",
    "intl-card-fc":"联想北京未来中心",
    "intl-card-shfc":"联想上海未来中心",
    "intl-card-szfc":"联想深圳未来中心",
    "intl-card-tjfc":"联想天津未来中心",
    "intl-card-enable2023":"2023年启用",
    "intl-card-enable2019":"2019年启用",
    "intl-card-enable2021":"2021年启用",
    "intl-shAboutUS-Closed":"闭馆时间",
    ...tj
};
export default zh_CN;


// WEBPACK FOOTER //
// ./src/langConfig/zh-CN.js